module.exports = __webpack_public_path__ + "static/media/SampleVideo_1280x720.d55bddf8.mp4";